"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FillViewHeightV2 = void 0;
var react_1 = __importStar(require("react"));
var domChangesConfig = { attributes: true, childList: true, subtree: true };
/**
 * FillViewHeightV2
 * UseCase:
 * It's used for special cases where you want the content to cover the full height of the device.
 */
var FillViewHeightV2 = function (_a) {
    var children = _a.children, childSelector = _a.childSelector, _b = _a.offset, offset = _b === void 0 ? "0px" : _b, _c = _a.className, className = _c === void 0 ? "" : _c, _d = _a.style, style = _d === void 0 ? {} : _d, _e = _a.styleKeys, styleKeys = _e === void 0 ? ["minHeight"] : _e;
    var R = react_1.useRef(null);
    react_1.useEffect(function () {
        function setHeightWithViewHeightAndTopAndFixedOffset(ele) {
            var top = ele.getBoundingClientRect().top;
            styleKeys.forEach(function (k) {
                // eslint-disable-next-line no-param-reassign
                ele.style[k] = "calc(100vh - " + offset + " - " + top + "px)";
            });
        }
        function recalibrateHeight() {
            if (R.current) {
                if (childSelector && R.current.querySelector(childSelector)) {
                    setHeightWithViewHeightAndTopAndFixedOffset(
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    R.current.querySelector(childSelector));
                }
                else {
                    setHeightWithViewHeightAndTopAndFixedOffset(R.current);
                }
            }
        }
        recalibrateHeight();
        window.addEventListener("resize", recalibrateHeight);
        var observer = new MutationObserver(recalibrateHeight);
        observer.observe(R.current, domChangesConfig);
        return function () {
            window.removeEventListener("resize", recalibrateHeight);
            observer.disconnect();
        };
    }, [childSelector, offset, styleKeys]);
    return (react_1.default.createElement("div", { ref: R, className: "wh-fill-view-height " + className, style: style }, children));
};
exports.FillViewHeightV2 = FillViewHeightV2;
